/* eslint-disable no-console */
type ConsoleMethods =
    | 'log'
    | 'error'
    | 'warn'
    | 'debug'
    | 'trace'
    | 'info'
    | 'time'
    | 'timeEnd';

export const createConsole = (
    enabled: boolean,
): Record<ConsoleMethods, (...args: any[]) => void> => {
    return {
        log: enabled ? console.log.bind(console) : () => {},
        error: enabled ? console.error.bind(console) : () => {},
        warn: enabled ? console.warn.bind(console) : () => {},
        debug: enabled ? console.debug.bind(console) : () => {},
        trace: enabled ? console.trace.bind(console) : () => {},
        info: enabled ? console.info.bind(console) : () => {},
        time: enabled ? console.info.bind(console) : () => {},
        timeEnd: enabled ? console.info.bind(console) : () => {},
    };
};
